/* eslint-disable max-len */
const { ConsentName } = require('../constants/consentName');
const { ConsentValue } = require('../constants/consentValue');
const { CONSENT_STORAGE_NAME } = require('../constants/consentStorageName');

const getConsentDeniedValues = function() {
  let consentState = {
    [ConsentName.AdStorage]: ConsentValue.Denied,
    [ConsentName.AnalyticsStorage]: ConsentValue.Denied,
    [ConsentName.PersonalizationStorage]: ConsentValue.Denied
  };
  try {
    consentState = JSON.parse(window.localStorage.getItem(CONSENT_STORAGE_NAME) || '{}') || {};

    consentState[ConsentName.AdStorage] = ConsentValue.Denied;
    consentState[ConsentName.AnalyticsStorage] = ConsentValue.Denied;
    consentState[ConsentName.PersonalizationStorage] = ConsentValue.Denied;
  } catch (e) {}

  return {
    [ConsentName.AdStorage]: consentState[ConsentName.AdStorage],
    [ConsentName.AnalyticsStorage]: consentState[ConsentName.AnalyticsStorage],
    [ConsentName.PersonalizationStorage]: consentState[ConsentName.PersonalizationStorage]
  };
};

module.exports = { getConsentDeniedValues };
